import { monthKeyFromT, parseMonthEnd } from '../engine/calendar'

const MONTH_ABBREV = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const

export type SummaryHorizon = {
  firstMonth: string
  lastMonth: string
  nMonths: number
}

export function formatHorizonMonthLabel(yyyyMm: string): string {
  const [yearStr, monthStr] = yyyyMm.split('-')
  const monthIdx = Number(monthStr) - 1
  return `${MONTH_ABBREV[monthIdx]} ${yearStr}`
}

export function summaryHorizon(lastClosedMonth: string): SummaryHorizon {
  const closed = parseMonthEnd(lastClosedMonth)
  const firstMonth = monthKeyFromT(lastClosedMonth, 1)
  const lastYear = closed.getFullYear() + 1
  const lastMonth = `${lastYear}-12`
  const [firstYearStr, firstMonthStr] = firstMonth.split('-')
  const firstYear = Number(firstYearStr)
  const firstMonthNum = Number(firstMonthStr)
  const nMonths = (lastYear - firstYear) * 12 + (12 - firstMonthNum) + 1
  return { firstMonth, lastMonth, nMonths }
}

export function summaryHorizonSentence(lastClosedMonth: string, caseName: string): string {
  const { firstMonth, lastMonth, nMonths } = summaryHorizon(lastClosedMonth)
  const first = formatHorizonMonthLabel(firstMonth)
  const last = formatHorizonMonthLabel(lastMonth)
  return `This will summarise ${first} \u2013 ${last}, ${nMonths} months, for ${caseName}`
}
